var selectors = [
  $tabs_click = $('.jump-to-tabs'),
  $tab_container = $('.wmwproduct__tabs'),
  $tabs = $('[js-action="tab"]'),
  $info = $('.wmwproduct__tabs__info'),
  $tab_details = $('[data-tab="Details"]'),
  $tab_video = $('[data-tab="Video"]'),
  $info_video = $('[data-info="Video"]'),
  $play_video = $('.wmwproduct__tabs__info__overlay'),
  $mobile_tabs = $('[js-action="mobile-tab"]'),
  $mobile_tab_video = $('[data-mobile-tab="Video"]'),
  $sku = $('[js-sku]'),
  $sku_select = $('.product-form__variants'),
  $variant_select = $('.single-option-selector'), 
  $bis_button = $('.wmwproduct__nostock'),
  $bis_form = $('.wmwproduct__nostock__form'),
  $bis_form_button = $('[js-action="bis_form"]'),
  $bis_message = $('.wmwproduct__nostock__form__message')
];

// SKU Changer

$variant_select.change(function () {
  var variant_price = $(this).find(':selected').data('price');
  if($('.wmwproduct__details__price--sale').length <= 0) {
    if($('p#ComparePrice-product-wmw-template').length > 0) {
      $('p#ComparePrice-product-wmw-template').text(variant_price);
    }else {
      $('p#ProductPrice-product-wmw-template').text(variant_price);
    }
  }

  setTimeout(function () {
    var variant_id = $sku_select.val();
    $('.product-form__variants option').each(function () {
      if ($(this).val() == variant_id) {
        var variant_sku = $(this).attr('data-sku');
        $sku.text(variant_sku);
      }
    });
    $bis_form_button.attr('data-variant-id', variant_id);
  }, 100);
});

// Modaal

$('[js-modal="image"]').modaal({
  type: 'image'
});


// Tabs Scrolls
$tabs_click.on('click', function () {
    $('html, body').animate({
        scrollTop : ($tab_container.offset().top) - $('.wmwnav__container').height()
    }, 500);
    $tab_details.trigger( "click" );
    return false;
})

// Back in stock

$bis_button.on('click', function () {
  $bis_form.toggle();
});

$bis_form_button.click(function (e) {
  e.preventDefault();
  var email = $('.wmwproduct__nostock__form input').val(),
  productId = $(this).data('product-id'),
  variantId = $(this).data('variant-id');
  BIS.create(email, variantId, productId).then(notificationCallback);
});

var notificationCallback = function (data) {
  var msg = '';
  if (data.status == 'OK') {
    msg = data.message;
    $bis_message.addClass('active').text(msg);
  } else {
    for (var k in data.errors) {
      msg += (k + " " + data.errors[k].join());
    }
    $bis_message.addClass('active error').text(msg);

    setTimeout(function () {
      $bis_message.removeClass('active');
      $bis_message.removeClass('error');
    }, 3000);
  }
};

$bis_message.on('click', function () {
  $(this).removeClass('active');
});

// Video API

function getVideoType() {
  if ($('[data-video-type]')) {
    return $('[data-video-type]').data('video-type');
  }
  return false
}

function getVideoId() {
  if ($('[data-video-id]')) {
    return $('[data-video-id]').data('video-id');
  }
}

var videoType = getVideoType();
var id = getVideoId();

if (videoType == 'youtube') {
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  var player;

  function onYouTubeIframeAPIReady() {
    player = new YT.Player('player', {
      height: '180',
      width: '320',
      videoId: id,
      events: {
        'onReady': onYouTubeReady
      }
    });
  };

  function onYouTubeReady() {
    $tab_video.show();
    $mobile_tab_video.show();
  };

  $play_video.on('click', function () {
    player.playVideo();
    $(this).removeClass('active');
  });

} else if (videoType == 'vimeo') {
  var options = {
    id: id,
    width: 320
  };

  var player = new Vimeo.Player('player', options);

  player.on('loaded', function() {
    $tab_video.show();
    $mobile_tab_video.show();
  });

  $play_video.on('click', function () {
    player.play();
    $(this).removeClass('active');
  });
}

// Scroll the page to reviews

$('a[href^="#reviews"]').on('click', function (e) {
  e.preventDefault();

  var target = this.hash;
  var $target = $(target);

  $('html, body').stop().animate({
    'scrollTop': $target.offset().top
  }, 900, 'swing');
});

// Tabs

$tabs.on('click', function () {
  var tab = $(this).data('tab');

  $tabs.removeClass('active');
  $info.removeClass('active');
  $mobile_tabs.removeClass('active');

  $('[data-tab="' + tab + '"]').addClass('active');
  $('[data-mobile-tab="' + tab + '"]').addClass('active');
  $('[data-info="' + tab + '"]').addClass('active');
});

$mobile_tabs.on('click', function () {
  var tab = $(this).data('mobile-tab');

  if (!$(this).hasClass('active')) {
    $tabs.removeClass('active');
    $info.removeClass('active');
    $mobile_tabs.removeClass('active');

    $('[data-tab="' + tab + '"]').addClass('active');
    $('[data-mobile-tab="' + tab + '"]').addClass('active');
    $('[data-info="' + tab + '"]').addClass('active');
  } else {
    $(this).removeClass('active');
    $info.removeClass('active');
  }
});

// Recommend Products

$('.wmwproduct__carousel').slick({
  dots: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

//Swatches

$('[js-action="swatch"]').click(function() {
  var $this = $(this);
  var $quantity = $('[js-target=quantity]');

  var selectedInputValue = $this.val();
  var inventory = Number($this.attr('data-inventory'));
  var backorder = $this.attr('data-backorder');
  var quantity = Number($quantity.val());

  $quantity.attr('data-inventory', inventory);
  $quantity.attr('data-backorder', backorder);

  // Show error message if no quantity
  if ((quantity > inventory) && (inventory > 0)) {
    $quantity.val(inventory);
  }

  $('[js-target=error]').removeClass('active');

  $('[js-target=quantity-selector]').show();
  
});

document.getElementById("AddToCart-product-wmw-template").addEventListener('click',function (e){
  var klaviyo_form = false;
  var klaviyo_popup = $('#AddToCart-product-wmw-template').data('klaviyo');

  if(klaviyo_form && klaviyo_popup == 'popup') {
    window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', 'Vd7x75']);
  }

});